// extracted by mini-css-extract-plugin
export default {"root":"Layout_root__nqZJ9","footer":"Layout_footer__OFT90","text":"Layout_text__6MZNA","leftBorder":"Layout_leftBorder__ddM5x","loginBackground":"Layout_loginBackground__B+ApV"};